import { useFormBuilderContextState } from 'components/FormBuilder/context';
import { CheckboxesErrors } from 'components/FormBuilder/schemas';

import { isCheckboxesDataField } from './helpers';

export const useCheckboxesDataField = () => {
  const { values, errors, ...rest } = useFormBuilderContextState();

  if (!isCheckboxesDataField(values)) {
    throw new Error(
      `useCheckboxesDataField must be used where a checkboxes input is expected, instead input of type: ${values.type} was received.`,
    );
  }

  return {
    ...rest,
    values,
    errors: errors as CheckboxesErrors,
  };
};
